// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared header used above lists (Orders / Users / Complaints),
   similar to Home's "Системные логи" block */

.list-summary-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  margin-bottom: 0;
  flex: 1 1;
  min-width: 0;
}

.list-summary-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.list-summary-icon {
  width: 40px;
  height: 40px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-primary);
}


.list-summary-title {
  font-family: var(--font-heading);
  font-size: 1.2rem;
  font-weight: 650;
  color: var(--text-heading);
  margin: 0;
}

.list-summary-subtitle {
  font-family: var(--font-data);
  font-size: 0.82rem;
  color: var(--text-secondary);
  margin: 2px 0 0 0;
  line-height: 1.15;
  font-weight: 500;
}

.list-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.list-summary-row .orders-sort-container,
.list-summary-row .users-sort-container,
.list-summary-row .complaints-sort-container {
  margin-bottom: 0;
}

`, "",{"version":3,"sources":["webpack://./src/css/list-summary.css"],"names":[],"mappings":"AAAA;6CAC6C;;AAE7C;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;;AAGA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;AAClB","sourcesContent":["/* Shared header used above lists (Orders / Users / Complaints),\n   similar to Home's \"Системные логи\" block */\n\n.list-summary-header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: row;\n  margin-bottom: 0;\n  flex: 1;\n  min-width: 0;\n}\n\n.list-summary-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.list-summary-icon {\n  width: 40px;\n  height: 40px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-primary);\n}\n\n\n.list-summary-title {\n  font-family: var(--font-heading);\n  font-size: 1.2rem;\n  font-weight: 650;\n  color: var(--text-heading);\n  margin: 0;\n}\n\n.list-summary-subtitle {\n  font-family: var(--font-data);\n  font-size: 0.82rem;\n  color: var(--text-secondary);\n  margin: 2px 0 0 0;\n  line-height: 1.15;\n  font-weight: 500;\n}\n\n.list-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.list-summary-row .orders-sort-container,\n.list-summary-row .users-sort-container,\n.list-summary-row .complaints-sort-container {\n  margin-bottom: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
